import 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import Label$1 from 'reakit/Label';

var Label = styled(Label$1).withConfig({
  displayName: "styled__Label",
  componentId: "zz0170-0"
})(["display:block;font-weight:", ";margin-bottom:", "rem;line-height:1;&{", ";}"], theme('fannypack.fontWeights.semibold'), space(1), theme('fannypack.Label.base'));

export default Label;
export { Label };
